// src/store/ducks/settings/users/restoreUserSaga.ts

import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { requestErrorHandler } from "utils";
import { RestoreUserActions } from "store/ducks/settings/users";

interface IRestoreRequest {
  id: string;
  onSuccess?: () => void;
  onFailure?: (error: any) => void;
}

export function* restoreUserRequest(action: any) {
  try {
    const { id, onSuccess } = action as IRestoreRequest;
    yield call(apiGeneral.patch, `/users/${id}/restore`);
    if (onSuccess) {
      onSuccess();
    }
    yield put(RestoreUserActions.success());
    notify("success", "Usuário restaurado com sucesso");
    if (onSuccess) onSuccess(); 
     } catch (error) {
        const { errorMessage } = requestErrorHandler(error);
        notify("error", errorMessage);
        yield put(RestoreUserActions.failure(errorMessage));
      }
 }
